import { render } from "./FormMarginGlobal.vue?vue&type=template&id=55a200ac"
import script from "./FormMarginGlobal.vue?vue&type=script&lang=js"
export * from "./FormMarginGlobal.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__